import { createStylesParamsWithDefaults } from '../PackagePicker/stylesParams';

export { customCssVars } from '../PackagePicker/stylesParams';

export default createStylesParamsWithDefaults({
  showPageTitle: false,
});
